import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { BIG_MARGIN, MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        marginLeft: MIDDLE_MARGIN,
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: BIG_MARGIN,
      },
    },
  }),
);
export default useStyles;
